import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import Component from '../lib/Component'

export default class ImageReveal extends Component {
    static selector = '.js-image-wrapper'

    initialize() {
        const $images = this.$el

        if ($images.length < 1) {
            return
        }

        this.onScroll()
    }

    onScroll() {
        const $images = this.$el

        ScrollTrigger.batch($images, {
            start: 'top 75%',
            once: true,
            onEnter: (batch) => {
                gsap.fromTo(
                    batch,
                    {
                        scaleY: 0,
                    },
                    {
                        scaleY: 1,
                        stagger: 0.1,
                        duration: 0.5,
                        ease: 'power4.out',
                        onComplete: () => {
                            for (let i = 0; i < batch.length; i++) {
                                batch[i]
                                    .querySelector('img')
                                    .classList.add('is-fully-loaded')
                            }
                        },
                    },
                )
            },
        })

        ScrollTrigger.addEventListener('refreshInit', () =>
            gsap.set($images, { scaleY: 1 }),
        )
    }
}
